import { Component, Input, OnInit } from '@angular/core';

export type InfoMessageType = "info" | "warning" | "error";

@Component({
  selector: 'mood-info-message',
  templateUrl: './info-message.component.html',
  styleUrls: ['./info-message.component.scss']
})
export class InfoMessageComponent implements OnInit {
  @Input() type: InfoMessageType = "info";

  @Input() message!: string;


  icon!: string;

  ngOnInit(): void {
    switch (this.type) {
      case "info":
        this.icon = "information-outline";
        break;

      case "warning":
        this.icon = "alert-outline";
        break;

      case "error":
        this.icon = "alert-octagon-outline";
        break;

      default:
        break;
    }
  }
}
